import { DollarOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Popconfirm, Select } from "antd";
import { FC, useState } from "react";
const { Option } = Select;

interface RequestPaymentButtonProps {
  updateEmbedding: (requests: any) => void;
  paymentTypes: any;
  disabled: boolean;
}

export const RequestPaymentButton: FC<RequestPaymentButtonProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm(); // Create a form instance

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    form.resetFields();
    setIsOpen(false);
  };

  const handleConfirm = () => {
    props.updateEmbedding({
      value: "requestPayment",
      message: "Request Payment",
      reason: form.getFieldValue("reason"),
      amount: form.getFieldValue("amount"),
      adhocPaymentType: form.getFieldValue("adhocPaymentType"),
      icon: <DollarOutlined />,
    });
    form.resetFields();
    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  const paymentOption = (paymentItems: any) => paymentItems.map((item: any) => {
   return <Option key={item} value={item}>{item}</Option>
   });

   const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const parsedValue = parseFloat(value);

    if (!isNaN(parsedValue) && parsedValue >= 0) {
      form.setFieldsValue({ amount: value });
    } else {
      form.setFieldsValue({ amount: "" });
    }
  };

  return (
    <>
      <Modal
        title="Request Payment"
        footer={null}
        open={isOpen}
        onCancel={handleCancel}
      >
        <Form form={form}>
          <Form.Item
            label="Amount"
            name="amount"
            rules={[
              {
                required: true,
                message: "Please input the amount!",
              },
            ]}
          >
            <Input
              type="number"
              placeholder="Enter Amount"
              style={{ width: "35%" }}
              min={0}
              onChange={handleAmountChange}
            />
          </Form.Item>
          {/* Note: the options for this dropdown should be derived from the additionalCharges types on the finance config for the current case type */}
          <Form.Item
            label="Payment Type"
            name="adhocPaymentType"
            rules={[
              {
                required: true,
                message: "Please select the payment type!",
              },
            ]}
          >
            <Select
              placeholder="Select Payment Type"
              style={{ width: "35%" }}
            >
              {paymentOption(props.paymentTypes)}
            </Select>
          </Form.Item>
          <Form.Item
            label="Reason"
            name="reason"
            rules={[
              {
                required: true,
                message: "Please input the reason!",
              },
            ]}
          >
            <Input placeholder="Enter Reason" />
          </Form.Item>
          <div style={{ display: "flex", flexDirection: "row-reverse" }}>
            <Popconfirm
              title="Are you sure?"
              description="Are you sure you want to request payment for this amount?"
              onConfirm={handleConfirm}
              onCancel={handleCancel}
            >
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginTop: 10 }}
              >
                Create Request
              </Button>
            </Popconfirm>
          </div>
        </Form>
      </Modal>
      <Button
        style={{
          width: "100%",
          borderRadius: "8px",
          marginRight: 10,
          marginBottom: 10,
          marginTop: 10,
        }}
        onClick={openModal}
        disabled={props.disabled || (props.paymentTypes && !props.paymentTypes.length)}
      >
        <DollarOutlined /> Request Payment
      </Button>
    </>
  );
};
